export default __webpack_public_path__ + "static/media/steps_monitoring.71ec251f.jpg";